<template>
  <a-card :bordered="false" class="m-t-10">
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">新建手动报销单</span>
  </a-card>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules">
      <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">报销对象</p>
      <div class="p-24">
        <a-form-item style='margin-bottom: 10px;'>
          <a-radio-group v-model:value="form.bill_target" @change='radioChange'>
            <a-radio :value="2">经销商</a-radio>
            <a-radio :value="1">门店</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="form.bill_target == 2 ? '经销商':'门店'" style='margin-bottom: 0;'>
          <a-input :placeholder="form.bill_target == 2 ? '请选择经销商':'请选择门店'" style="width: 380px;margin-right: 10px;" readonly v-model:value="form.bill_target_name"></a-input>
          <a-button type="primary" @click="showStore = true" >添加{{form.bill_target == 2 ? '经销商':'门店'}}</a-button>
        </a-form-item>
      </div>
      <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">报销内容</p>
      <div class="p-24">
        <p class="fz-18 s_font_b m-b-20">积分</p>
        <a-form-item label="积分">
          <a-input-number style="width: 380px" v-model:value="form.point_num" placeholder="请输入积分" :min='0' :max='pointData' :precision='0' :disabled='!pointData'></a-input-number>
          <span class="s_c999" v-if='form.bill_target_name'>（报销对象最多可报销{{pointData}}积分）</span>
        </a-form-item>
        <p class="fz-18 s_font_b m-b-20">优惠券</p>
        <a-table :pagination='false' :loading='couponListLoading' bordered rowKey='ids' :columns='columnsCoupon' :data-source='couponData' :row-selection="{ selectedRowKeys: couponRowKeys, onChange: onCouponSelectChange }"></a-table>
        <p class="fz-18 s_font_b m-b-20 m-t-20">礼品</p>
        <a-table :pagination='false' :loading='giftListLoading' bordered rowKey='ids' :columns='columnsGift' :data-source='giftData' :row-selection="{ selectedRowKeys: giftRowKeys, onChange: onGiftSelectChange }">
          <template v-slot:gift_name="{ record }">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+(record.exchange_image)" alt="" style="width:50px;height:50px">
              </template>
              <template #description>
                <p class="s_omit2" style="width: 320px;">{{record.exchange_name}}</p>
              </template>
            </a-card-meta>
          </template>
        </a-table>
        <a-pagination  :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
        <div class="m-t-25">
          <a-button class="width-120 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
          <a-button class="width-120" block type="primary" @click="onSubmit">生成报销单</a-button>
        </div>
      </div>
    </a-form>
  </a-card>
  <a-modal  :keyboard="false" :title="form.bill_target == 2 ? '选择经销商':'选择门店'" v-model:visible="showStore" centered :width='1300' :footer="null" destroyOnClose>
    <selectObjectStore v-on:select="storeSelect" :selectList='[{store_id:form.store_id}]' :checkout='false' :type='form.bill_target'></selectObjectStore>
  </a-modal>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { LeftOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { addReimbursment,addReimbursmentCoupon,addReimbursmentGift,addReimbursmentPoint } from '@/api/reimbursement';
import { iscode } from "@/utils/app";
import store from "@/store";
import selectObjectStore from './components/select'
let defForm = {
  bill_target:2,
  store_id:'',
  bill_target_name:'',
  point_num:'',
  coupon_ids:[],
  gift_ids:[]
};
let defSearch = {
  page:1,
  limit:10
}
export default {
  components: { LeftOutlined ,selectObjectStore},
  setup() {
    const ruleForm = ref();
    const form = ref({ ...defForm });
    const search = ref({ ...defSearch });
    const state = reactive({
      info: store.state.user.info,
      pointData:0,
      couponData:[],
      couponRowKeys:[],
      giftData:[],
      giftRowKeys:[],
      total:0,
      showStore:false,
      couponListLoading:false,
      giftListLoading:false
    });
    let columnsCoupon = [
      {
        title: "优惠券类型",
        dataIndex: "coupon_name",
        key: "coupon_name",
      },
      {
        title: "数量",
        dataIndex: "coupon_num",
        key: "coupon_num"
      },
      {
        title: "总抵扣金额（元）",
        dataIndex: "coupon_price",
        key: "coupon_price",
      },
    ];
    let columnsGift = [
      {
        title: "礼品信息",
        dataIndex: "gift_name",
        key: "gift_name",
        slots: { customRender: "gift_name" },
      },
      {
        title: "数量",
        dataIndex: "num",
        key: "num"
      }
    ];
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      getGift();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      getGift();
    };
    const radioChange = () =>{
      form.value.bill_target_name="";
      form.value.store_id="";
      state.couponData=[];
      state.giftData=[];
      state.pointData=0
    }
    //选择门店/经销商
    const storeSelect = (e) =>{
      form.value.store_id = e.store_id;
      form.value.bill_target_name = e.store_name;
      state.showStore = false;
      form.value.point_num = '';
      state.couponRowKeys = [];
      state.giftRowKeys = [];
      getCoupon();
      getPoint();
      getGift();
    }
    // 获取优惠券列表
    const getCoupon = async () => {
      state.couponListLoading = true
      let res = await addReimbursmentCoupon({ store_id: form.value.store_id }).then((res) => res.data);
      if (iscode(res)) {
        state.couponData = res.data
      } else {
        message.error(res.msg);
      }
      state.couponListLoading = false
    };
    // 获取礼品列表
    const getGift = async () => {
      state.giftListLoading = true
      let res = await addReimbursmentGift({...search.value, store_id: form.value.store_id }).then((res) => res.data);
      if (iscode(res)) {
        state.giftData = res.data.data;
        state.total = res.data.total
      } else {
        message.error(res.msg);
      }
      state.giftListLoading = false
    };
    // 获取积分
    const getPoint = async () => {
      let res = await addReimbursmentPoint({ store_id: form.value.store_id }).then((res) => res.data);
      if (iscode(res)) {
        state.pointData = res.data.point;
      } else {
        message.error(res.msg);
      }
    };
    //优惠券多选
    const onCouponSelectChange = (changeableRowKeys) =>{
      state.couponRowKeys = changeableRowKeys
    };
    //礼品多选
    const onGiftSelectChange = (changeableRowKeys) =>{
      state.giftRowKeys = changeableRowKeys
    };
    //提交
    const onSubmit = () => {
      ruleForm.value.validate().then(() => {
        $Modal.confirm({
          centered:true,
          title:'确定生成报销单？',
          content: '生成的报销单直接完成审批流程，内容和对象都不可更改', 
          async onOk(){
            const hide = message.loading("正在加载中...", 0);
            let res = await addReimbursment({...form.value,coupon_ids:_lodash.flattenDeep(state.couponRowKeys),gift_ids:_lodash.flattenDeep(state.giftRowKeys)}).then((res) => res.data).catch(error=>error);
            if (iscode(res)) {
              message.success(res.msg);
              setTimeout(() => {
                $router.go(-1);
              }, 2000);
            } else {
              message.error(res.msg);
            }
            setTimeout(hide);
          }
        })
      }).catch(error => {
        message.error('请完善表单！');
      });
    };
    onMounted(() => {
      // initData();
    });
    return {
      form,
      ruleForm,
      search,
      columnsGift,
      columnsCoupon,
      ...toRefs(state),
      onSubmit,
      onCouponSelectChange,
      onGiftSelectChange,
      pageCurrentChange,
      pageSizeChange,
      storeSelect,
      radioChange
    };
  },
};
</script>
